import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa32010e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "guest-links-container" }
const _hoisted_2 = ["src", "alt", "onClick"]
const _hoisted_3 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guests, (guest) => {
      return (_openBlock(), _createElementBlock("div", {
        key: guest,
        class: "guest-link-img-wrapper"
      }, [
        _createElementVNode("img", {
          src: _ctx.getFormattedImage(guest._id),
          alt: guest.name,
          onClick: ($event: any) => (_ctx.sortGuestPath(guest)),
          class: "guest-link"
        }, null, 8, _hoisted_2),
        _createElementVNode("span", {
          id: guest._id
        }, _toDisplayString(guest.name), 9, _hoisted_3)
      ]))
    }), 128))
  ]))
}